export default __webpack_public_path__ + "static/media/img_2.6e275a02.jpg";